<div id="monthly-detailed-container">
  <p class="subheading-01-bold title">Valor anual</p>
  <p *ngIf="!this.isEdit; else editanual" class="paragraph-01-regular info">
    <span
      *ngIf="
        this.value.data.goalName != 'Transacciones' &&
        this.value.data.goalName != 'Porcentaje de transacción compartida'
      "
      >U$S
    </span>
    {{ this.value.data.anual | truncateDecimal : 2 }}
  </p>
  <ng-template #editanual>
    <div class="input-container">
      <qr-input
        id="input-normal"
        [config]="input"
        [restrictDecimalInput]="true"
        [value]="annual.display"
        (valueChange)="onAnnualInput($event)"
        (blurChange)="commitAnnualValue()"
      ></qr-input>
    </div>
  </ng-template>
  <div id="month-container">
    <div
      *ngFor="let month of this.months; trackBy: trackByMonthKey"
      class="item-month"
    >
      <p class="subheading-01-bold title">{{ month.label }}</p>
      <p *ngIf="!this.isEdit; else editmonth" class="paragraph-01-regular info">
        <span
          *ngIf="
            this.value.data.goalName != 'Transacciones' &&
            this.value.data.goalName != 'Porcentaje de transacción compartida'
          "
          >U$S
        </span>
        {{ month.amount.value | truncateDecimal : 2 }}
      </p>
      <ng-template #editmonth>
        <div class="input-container">
          <qr-input
            id="input-normal"
            [config]="input"
            [restrictDecimalInput]="true"
            [value]="month.amount.display"
            (valueChange)="onMonthInput($event, month)"
            (blurChange)="commitMonthValue(month)"
          ></qr-input>
        </div>
      </ng-template>
    </div>
  </div>
</div>
